import { Tooltip } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

const CustomTooltip = ({ title, placement = "top", children }) => {
  const theme = useTheme();

  return (
    <Tooltip
      title={title}
      placement={placement}
      arrow
      PopperProps={{
        sx: {
          '& .MuiTooltip-tooltip': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
          },
          '& .MuiTooltip-arrow': {
            color: theme.palette.primary.main,
          }
        }
      }}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
